import { GlobalAuditlogListSuccess } from '../../actionTypes/auditlogActions';

const inititalState = {
  globalauditlogList: [],
};

export const auditlogReducer = (state = inititalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GlobalAuditlogListSuccess:
      return {
        ...state,
        globalauditlogList: payload,
      };
    default:
      return state;
  }
};
